<div class="main">
    <div class="page-header">
        <div class="header-left">
            <h1 class="page-title">Edit User Role</h1>
            <p class="page-description">
                Update role-based access control and permissions
            </p>
        </div>
    </div>

    <form
        [formGroup]="roleForm"
        (ngSubmit)="onSubmit()"
        class="permissions-form"
    >
        <div class="card permission-card">
            <div class="card-header">
                <h3 class="card-title">
                    <i class="fas fa-user-tag"></i>
                    Role Information
                </h3>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label for="roleName" class="form-label">
                        Role Name <span class="required">*</span>
                    </label>
                    <input
                        type="text"
                        id="roleName"
                        formControlName="roleName"
                        class="form-control"
                        placeholder="Enter role name (e.g., Administrator, Manager)"
                    />
                    <div
                        *ngIf="
                            roleForm.get('roleName').invalid &&
                            roleForm.get('roleName').touched
                        "
                        class="error-message"
                    >
                        <i class="fas fa-exclamation-circle"></i> Role name is
                        required
                    </div>
                </div>
            </div>
        </div>

        <div class="card permission-card">
            <div class="card-header">
                <h3 class="card-title">
                    <i class="fas fa-chart-line"></i>
                    Dashboard Permissions
                </h3>
            </div>
            <div class="card-body">
                <div formGroupName="dashboard">
                    <div formGroupName="permissions" class="permissions-grid">
                        <div
                            class="permission-checkbox-item"
                            *ngFor="let permission of permissions"
                        >
                            <label class="checkbox-label">
                                <input
                                    type="checkbox"
                                    [formControlName]="
                                        permission.permissionName
                                    "
                                />
                                <span class="checkbox-custom"></span>
                                <span class="checkbox-text">{{
                                    permission.permissionName
                                }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card permission-card">
            <div class="card-header">
                <h3 class="card-title">
                    <i class="fas fa-folder-tree"></i>
                    Catalog Permissions
                </h3>
            </div>
            <div class="card-body">
                <div formArrayName="catalog">
                    <div class="permissions-table-container">
                        <div class="permissions-table-header">
                            <div class="module-name-col">Catalog</div>
                            <div class="permissions-header-cols">
                                <div
                                    class="permission-col"
                                    *ngFor="let permission of permissions"
                                >
                                    {{ permission.permissionName }}
                                </div>
                            </div>
                        </div>

                        <div
                            *ngFor="
                                let section of catalogFormArray.controls;
                                let i = index
                            "
                            [formGroupName]="i"
                            class="permissions-table-row"
                        >
                            <div class="module-name-col">
                                <span class="module-label">{{
                                    section.get('sectionName').value
                                }}</span>
                            </div>
                            <div
                                formGroupName="permissions"
                                class="permissions-header-cols"
                            >
                                <div
                                    class="permission-col"
                                    *ngFor="let permission of permissions"
                                >
                                    <label class="checkbox-label-inline">
                                        <input
                                            type="checkbox"
                                            [formControlName]="
                                                permission.permissionName
                                            "
                                        />
                                        <span
                                            class="checkbox-custom-inline"
                                        ></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-actions">
            <button
                class="btn-action-primary"
                type="submit"
                [disabled]="isLoading$ | async"
            >
                <i class="fas fa-spinner fa-spin" *ngIf="isAuthLoading"></i>
                <span *ngIf="!isAuthLoading">Update Permissions</span>
                <span *ngIf="isAuthLoading">Updating...</span>
            </button>
        </div>
    </form>
</div>
